<template>
  <div class="denied-page">
    <div class="denied-code">403</div>
    <h2>当前账号无权访问此页面</h2>
    <button type="button" @click="$router.push('/dashboard')">返回工作台</button>
  </div>
</template>
<script>export default { name: "AccessDeniedView" }</script>
<style scoped>
.denied-page { min-height: 460px; display: grid; place-content: center; justify-items: center; color: #526171; }
.denied-code { font-size: 48px; font-weight: 800; color: #c1493c; }
h2 { margin: 10px 0 22px; font-size: 18px; letter-spacing: 0; }
button { height: 38px; padding: 0 15px; border: 1px solid #cfd7df; border-radius: 6px; background: #fff; color: #334155; cursor: pointer; }
</style>
